export default "__VITE_ASSET__8GM2SkYA__"